import { Box, NavLink } from '@mantine/core';
import { IconBook, IconHelp, IconMessageCircle, IconMessageQuestion } from '@tabler/icons-react';

// アカウントは Chat と共通なので、同じアカウントのまま Chat を開ける
const plamoChatUrl = import.meta.env.VITE_PLAMO_CHAT_URL;

const iconProps = {
  size: '1.4em',
  stroke: 1.5,
};

export function ExternalNavLinks() {
  return (
    <Box>
      {plamoChatUrl && (
        <NavLink
          href={plamoChatUrl}
          target="_blank"
          label="PLaMo Chat"
          leftSection={<IconMessageCircle {...iconProps} />}
        />
      )}
      <NavLink
        href="https://docs.plamo.preferredai.jp"
        target="_blank"
        label="ドキュメント"
        leftSection={<IconBook {...iconProps} />}
      />
      <NavLink
        href="https://support.plamo.preferredai.jp"
        target="_blank"
        label="ヘルプ"
        leftSection={<IconHelp {...iconProps} />}
      />
      <NavLink
        href="https://support.plamo.preferredai.jp/hc/ja/requests/new"
        target="_blank"
        label="お問合せ"
        leftSection={<IconMessageQuestion {...iconProps} />}
      />
    </Box>
  );
}
